import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1C1917] text-white/80 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3 className="font-serif text-2xl text-white">Gledswood Homestead & Winery</h3>
          <p className="mt-3 text-sm leading-relaxed text-white/60">
            Boutique Australian wines & grazing in the heart of the Camden Valley.
          </p>
        </div>
        <div>
          <p className="text-sm uppercase tracking-wider font-semibold text-white/50">Visit Us</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>900 Camden Valley Way, Gledswood Hills NSW 2557</li>
            <li>Cellar door: Thu–Sat 11am–2pm</li>
            <li>First Sunday of each month 11am–2pm</li>
            <li>Friday Night Wine Bar 6pm–11pm</li>
          </ul>
        </div>
        <div>
          <p className="text-sm uppercase tracking-wider font-semibold text-white/50">More</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <button
                onClick={() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })}
                className="hover:text-white transition-colors"
                data-testid="footer-book-link"
              >
                Book a Tasting
              </button>
            </li>
            <li>
              <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">
                Staff Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-8 border-t border-white/10 text-xs text-white/40">
        © {new Date().getFullYear()} Gledswood Cellar Door. All rights reserved.
      </div>
    </footer>
  );
}
